import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export function UrgencyBar() {
  const [cupos, setCupos] = useState(53);
  useEffect(() => {
    const interval = setInterval(() => {
      setCupos(prev => {
        if (prev <= 1) return 1;
        return prev - 1;
      });
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  return <div className="sticky top-0 z-50 w-full bg-urgency text-white py-3 px-4 shadow-md" data-id="element-228">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-3 md:gap-5 text-center text-sm md:text-base font-medium" data-id="element-229">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-230">
          ⏳ OFERTA: Solo los primeros 200 acceden por $6.36. Precio sube a $37
          en 24 horas.
        </motion.span>

        <div className="flex items-center gap-2 bg-white/15 rounded-full px-3 py-1" data-id="element-231">
          <span className="relative flex h-2.5 w-2.5" data-id="element-232">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-233"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-400" data-id="element-234"></span>
          </span>
          <AnimatePresence mode="wait" data-id="element-235">
            <motion.span key={cupos} initial={{
            y: -8,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} exit={{
            y: 8,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="font-bold text-sm" data-id="element-236">
              🔥 {cupos} cupos disponibles
            </motion.span>
          </AnimatePresence>
        </div>

        <Button onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })} className="py-2 px-4 text-sm md:text-sm !animate-none shadow-none" data-id="element-237">
          QUIERO MI ACCESO AHORA
        </Button>
      </div>
    </div>;
}